import Vue from 'vue'
import Router from 'vue-router'
import IndexPage from "./components/IndexPage.vue";
import ShopPage from "./components/ShopPage.vue";
import AboutusPage from "./components/AboutusPage.vue";
import ContactusPage from "./components/ContactusPage.vue"
import PartnersPage from "./components/PartnersPzge.vue"
import CartPage from "./components/CartPage.vue"
import CheckoutPage from "./components/CheckoutPage.vue"
import DetailPage1 from "./components/DetailPage1.vue"
import DetailPage2 from "./components/DetailPage2.vue"
import DetailPage3 from "./components/DetailPage3.vue"
import DetailPage4 from "./components/DetailPage4.vue"




Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: IndexPage
    },
    {
      path: '/shop',
      name: 'Shop',
      component: ShopPage
    },
    {
      path: '/about',
      name: 'about',
      component: AboutusPage
    },

    {
      path: '/contact',
      name: 'contact',
      component: ContactusPage
    },


    
    {
      path: '/partners',
      name: 'partners',
      component: PartnersPage
    },
      
    {
      path: '/cart',
      name: 'cart',
      component:CartPage
    },

     {
      path: '/checkout',
      name: 'checkout',
      component:CheckoutPage
    },

     {
      path: '/Detail',
      name: 'Detail',
      component:DetailPage1
    },

     {
      path: '/Detail 1',
      name: 'Detail 1',
      component:DetailPage2
    },

   
  

     {
      path: '/Detail 3',
      name: 'Detail 3',
      component:DetailPage3
    },
   
   

     {
      path: '/Detail 4',
      name: 'Detail 4',
      component:DetailPage4
    }

  ]
})
